module.exports = __webpack_public_path__ + "static/media/onbording-homeowner-img.cdccc377.png";